export enum VehicleStatusEnum {
  Undefined = 'Undefined',
  Pending = 'Pending',
  Approved = 'Approved',
  Deleted = 'Deleted',
}
